import * as React from 'react';
import { config } from '../../../config';
import { biLogger } from '../../../bi';
import { Modal, MessageBoxMarketerialLayout } from 'wix-style-react';
import { composer } from '../../../component-decorators/composer';
export var UpgradeSiteModal = composer()
    .withTranslation()
    .withMarketplaceStore()
    .compose(function (_a) {
    var t = _a.t, appId = _a.appId, msid = _a.msid, marketplaceStore = _a.marketplaceStore, appName = _a.appName;
    var handleClose = function () {
        // tslint:disable-next-line: no-floating-promises
        biLogger.appMarketCloseDialogBoxOfUpgradeWixX({
            app_id: appId,
            msid: msid,
        });
        marketplaceStore.closeAllModals();
    };
    var handleConnect = function () {
        // tslint:disable-next-line: no-floating-promises
        biLogger.appMarketUpgradeWixSiteClick({
            app_id: appId,
            msid: msid,
        });
        window.open("https://premium.wix.com/wix/api/premiumStart?siteGuid=" + marketplaceStore.metaSiteId + "&referralAdditionalInfo=marketplace" + config.origin);
    };
    // tslint:disable-next-line: no-floating-promises
    biLogger.appMarketUpgradeSiteConnectDomainDialogBox({
        appId: appId,
        msid: msid,
        stepName: 'upgrade_site',
    });
    return (React.createElement(Modal, { isOpen: true },
        React.createElement(MessageBoxMarketerialLayout, { title: t('modals-upgradeSite-header', { appName: appName }), content: t('modals-upgradeSite-content'), imageUrl: config.marketplaceStaticsUrl + "assets/images/upgrade-site-icon.png", theme: "purple", primaryButtonLabel: t('modals-upgradeSite-cta'), onClose: function () { return handleClose(); }, onPrimaryButtonClick: function () { return handleConnect(); } })));
});
//# sourceMappingURL=updare-site-modal.js.map